/**
 * This receives the hex color code and return returns corresponding hexcode
 * @param colorCode
 * @returns {`#${string}`}
 */
export default colorCode => `#${colorCode}`
